import { render } from "./PhoneIcon.vue?vue&type=template&id=3d366daf&scoped=true"
const script = {}

import "./PhoneIcon.vue?vue&type=style&index=0&id=3d366daf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d366daf"]])

export default __exports__